export default __webpack_public_path__ + "assets/server.ce5dd27f.svg";